import Image, { ImageProps } from "next/image"
import { cloudflareLoader } from "./imageMap"

const CdnImage = (props: ImageProps) => {
  return <Image loader={cloudflareLoader} {...props} />
}

export default CdnImage
